export default {"src":"/_next/static/media/logo_dark.21d7c732.svg","height":200,"width":600,"blurWidth":0,"blurHeight":0};